import { Box, Button, Flex } from "@chakra-ui/react";
import { FC } from "react";
import { formFooterStyle } from "../../../utils/styles/styles";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import LoadingButton from "../../atom/Button/LoadingButton/LoadingButton";
import { goBack } from "../../../helpers/goBack";
import { NavigateFunction } from "react-router-dom";

interface FormFooterProps {
  isReturnActive: boolean;
  isNextActive: boolean;
  onBack: () => void;
  onNext: () => void;
  isFinalStep: boolean;
  isScrolled?: boolean;
  handleCancel: () => void;
  nextButtonName?: string;
  finishButtonName?: string;
  nextButtonDisabled?: boolean;
  returnButtonDisabled?: boolean;
  isLoaded: boolean;
  pathname: string;
  navigate: NavigateFunction;
}

const FormFooter: FC<FormFooterProps> = ({
  isReturnActive,
  isNextActive,
  onBack,
  onNext,
  isFinalStep,
  isScrolled,
  handleCancel,
  nextButtonName = "",
  finishButtonName = "",
  nextButtonDisabled,
  returnButtonDisabled,
  isLoaded = true,
  pathname,
  navigate,
}) => {
  return (
    <Box
      position="fixed"
      style={{
        ...formFooterStyle,
        boxShadow: isScrolled
          ? "0px -6px 22px 0px rgba(0, 0, 0, 0.11)"
          : "none",
      }}
    >
      <Flex justifyContent="flex-start" alignItems="space-between">
        <Flex flex="1" gap="4" alignItems="center">
          <Button
            variant="secondary"
            leftIcon={<ChevronLeftIcon boxSize={5} />}
            isDisabled={!isReturnActive || returnButtonDisabled}
            onClick={onBack}
          >
            Recuar
          </Button>
          <Button variant="tertiary" onClick={handleCancel}>
            Cancelar
          </Button>
        </Flex>
        <Flex gap="4">
          {finishButtonName && (
            <Button
              variant="secondary"
              onClick={() => goBack(navigate, pathname)}
            >
              {finishButtonName}
            </Button>
          )}
          <LoadingButton
            variant="primary"
            rightIcon={
              isLoaded && !isFinalStep ? (
                <ChevronRightIcon boxSize={5} />
              ) : undefined
            }
            isDisabled={!isNextActive}
            onClick={onNext}
            colorScheme={isFinalStep ? "green" : "default"}
            isLoading={!isLoaded}
            isButtonDisabled={nextButtonDisabled ? nextButtonDisabled : false}
          >
            {isFinalStep ? nextButtonName : "Avançar"}
          </LoadingButton>
        </Flex>
      </Flex>
    </Box>
  );
};

export default FormFooter;
